export {default} from './memory.vue'
